import client from "./client";

export const optionsAPI = () => (
	client({
		url: '/v1/options',
		params: '',
		isAuth: false,
	})
)